var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"ENMvwpqc7404saeNxO_WZ"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';
import getConfig from 'next/config';
import { sentryDenyUrls } from '@root/sentry-deny-urls';

const IGNORE_ERRORS = [
  'window.lintrk is not a function',
  'nr-spa-',
  'ResizeObserver loop limit exceeded',
  'Could not establish connection. Receiving end does not exist.'
];

/**
 * This script is used to initialize Sentry on the client side.
 * It's done as a self-invoking function to poll the DOM for the __SCRIBE_ENV__ element.
 */
(async function () {
  async function getActualConfig() {
    let config = getConfig();

    if (config) {
      const { sentryDsn, ENV: env } = config.publicRuntimeConfig;

      return { sentryDsn, env };
    }

    return new Promise((resolve) => {
      const observer = new MutationObserver(resolveConfigAndDisconnectIfExists);

      observer.observe(document.head, { childList: true, subtree: true });

      resolveConfigAndDisconnectIfExists();

      function resolveConfigAndDisconnectIfExists() {
        const envEl = document.getElementById('__SCRIBE_ENV__');

        if (!envEl) return;
        resolve(JSON.parse(envEl.textContent));
        observer.disconnect();
      }
    });
  }

  const { sentryDsn, env } = await getActualConfig();

  if (!sentryDsn) return; // e.g. local environments

  Sentry.init({
    dsn: sentryDsn,
    debug: env !== 'production',
    environment: env,
    includeLocalVariables: true,
    integrations: [
      Sentry.rewriteFramesIntegration({
        iteratee: (frame) => {
          frame.filename = frame.filename.replace('.next', '_next');
          return frame;
        }
      }),
      Sentry.httpContextIntegration(),
      Sentry.httpClientIntegration(),
      Sentry.extraErrorDataIntegration()
    ],
    tracePropagationTargets: ['localhost', /^https?:\/\/.*\.(scribehow|scribehow-.*|cursive)\.(?:com|io)/],
    tracesSampleRate: 0.25,
    ignoreErrors: IGNORE_ERRORS,
    denyUrls: sentryDenyUrls
  });
})();
